/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterItemDto } from './FilterItemDto';
import {
    FilterItemDtoFromJSON,
    FilterItemDtoFromJSONTyped,
    FilterItemDtoToJSON,
    FilterItemDtoToJSONTyped,
} from './FilterItemDto';

/**
 * 
 * @export
 * @interface GetSimulationFilterResponseDto
 */
export interface GetSimulationFilterResponseDto {
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof GetSimulationFilterResponseDto
     */
    products: Array<FilterItemDto>;
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof GetSimulationFilterResponseDto
     */
    owners: Array<FilterItemDto>;
    /**
     * 
     * @type {Array<FilterItemDto>}
     * @memberof GetSimulationFilterResponseDto
     */
    statuses: Array<FilterItemDto>;
}

/**
 * Check if a given object implements the GetSimulationFilterResponseDto interface.
 */
export function instanceOfGetSimulationFilterResponseDto(value: object): value is GetSimulationFilterResponseDto {
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('owners' in value) || value['owners'] === undefined) return false;
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    return true;
}

export function GetSimulationFilterResponseDtoFromJSON(json: any): GetSimulationFilterResponseDto {
    return GetSimulationFilterResponseDtoFromJSONTyped(json, false);
}

export function GetSimulationFilterResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSimulationFilterResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'products': ((json['products'] as Array<any>).map(FilterItemDtoFromJSON)),
        'owners': ((json['owners'] as Array<any>).map(FilterItemDtoFromJSON)),
        'statuses': ((json['statuses'] as Array<any>).map(FilterItemDtoFromJSON)),
    };
}

export function GetSimulationFilterResponseDtoToJSON(json: any): GetSimulationFilterResponseDto {
    return GetSimulationFilterResponseDtoToJSONTyped(json, false);
}

export function GetSimulationFilterResponseDtoToJSONTyped(value?: GetSimulationFilterResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': ((value['products'] as Array<any>).map(FilterItemDtoToJSON)),
        'owners': ((value['owners'] as Array<any>).map(FilterItemDtoToJSON)),
        'statuses': ((value['statuses'] as Array<any>).map(FilterItemDtoToJSON)),
    };
}

